import { render } from "./work-view.html?vue&type=template&id=25a3d6b6&scoped=true&ts=true"
import script from "./work-view.ts?vue&type=script&lang=ts"
export * from "./work-view.ts?vue&type=script&lang=ts"

import "./work-view.scss?vue&type=style&index=0&id=25a3d6b6&lang=scss&scoped=true"

import exportComponent from "D:\\DEV\\Vue\\work\\vue_sotec_main\\vue_sotec_main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a3d6b6"]])

export default __exports__